import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	settings: {
		id: 'polaris-ideas.settings.fields.project-fields-screen.fields-list.cell.settings.settings',
		defaultMessage: 'Settings',
		description: 'Settings button label',
	},
});
